module.exports = __webpack_public_path__ + "static/media/toilet-paper-alt.10d0ff22.svg";